module.exports = __webpack_public_path__ + "static/media/Smart Integration.74f587f1.svg";